module.exports = __webpack_public_path__ + "img/zz-row-nine.14785834.svg";